import DeleteDialog from 'shell/components/shared/delete-dialog';
import { Fragment, useState, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import TableCard from 'civil-status/components/notes-text/table';
import { NotesTextListCrumbs } from 'civil-status/constants/notes-text-breadcrumb';
import ListHeader from 'shell/components/shared/list-header';
import { generatePath, useNavigate } from 'react-router-dom';
import { NotesTextItemVM } from 'civil-status/view-models/notes-text-list';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { HttpResponseList } from 'shell/models/http-response';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { NotesText } from 'shell/models/notes-text';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { authsRowNotesText } from 'civil-status/components/notes-text/table/table-row';

const NotesTextList = (): React.ReactElement => {
  const [elementToDelete, setElementToDelete] = useState<null | NotesTextItemVM>(null);
  const navigate = useNavigate();

  const [notesText, getNotesText] = useHttpFetch<
    HttpResponseList<NotesText>,
    Array<NotesTextItemVM>
  >(`${__CIVIL_STATUS_API_URL__}/testo-annotazione`, {
    onBootstrap: true,
    options: {
      method: 'GET',
    },
    transformer: (response) =>
      (response?.data?.payload?.list || []).map(
        (item) =>
          ({
            code: item.key?.idAnnotazione || '',
            title: item.titolo || '',
            text: item.annotazione || '',
            type: item.tipoAnnotazione || '',
          } as NotesTextItemVM)
      ),
  });

  const notesTextData = (notesText.data as Array<NotesTextItemVM>) || [];

  const deleteItem = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/testo-annotazione/cancellazione-testo-annotazione`,
    {
      options: {
        method: 'DELETE',
      },
    }
  );

  const clearToDelete = useCallback(() => setElementToDelete(null), [setElementToDelete]);

  const onConfirm = useCallback((): void => {
    if (elementToDelete) {
      (deleteItem({ url: `/${elementToDelete.code}` }) as ResponsePromise<void>).then(() => {
        getNotesText();
        setElementToDelete(null);
      });
    }
  }, [elementToDelete, deleteItem, getNotesText, setElementToDelete]);

  const auths = useActionAuthorization(authsRowNotesText);

  return (
    <Fragment>
      <Breadcrumbs items={NotesTextListCrumbs} />
      <ListHeader
        addBtnAriaLabel="Aggiungi nuova annotazione"
        addBtnLabel="Aggiungi nuova annotazione"
        canAdd={auths.add}
        onAddBtnClick={() => {
          navigate('/stato-civile/annotazioni/nuovo');
        }}
        title="Lista Annotazioni"
      />
      <div className="pmi-mt-2">
        <TableCard
          items={notesTextData}
          onTrashPress={(card) => setElementToDelete(card)}
          onEditPress={(item) =>
            navigate(generatePath(`/stato-civile/annotazioni/modifica/:id`, { id: item.code }))
          }
          onVisibilityPress={(item) =>
            navigate(generatePath(`/stato-civile/annotazioni/dettaglio/:id`, { id: item.code }))
          }
        />
      </div>
      {Boolean(elementToDelete) ? (
        <DeleteDialog
          isOpen={Boolean(elementToDelete)}
          onAbort={clearToDelete}
          onClose={clearToDelete}
          onConfirm={onConfirm}
        />
      ) : null}
    </Fragment>
  );
};

NotesTextList.displayName = 'Stamp certificate list page component';

export default NotesTextList;
